import { render, staticRenderFns } from "./AssignAsset.vue?vue&type=template&id=3d6e54c0&"
import script from "./AssignAsset.vue?vue&type=script&lang=js&"
export * from "./AssignAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports